export default {"src":"/_next/static/media/ship-camps-text-only.ab064b74.svg","height":16,"width":78,"blurWidth":0,"blurHeight":0};